import * as services from '../services';

export default {
  namespace: 'dr',

  state: {
    diagramApprovalList: [],
    searchValue: {},
  },

  effects: {
    //设置查询的参数
    *setSearchValue({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          searchValue: values,
        },
      });
    },
    //查询决策图版本审计
    *getDiagramApprovalList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(
        services.getDiagramApprovalList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          diagramApprovalList: response || [],
        },
      });
    },
    //通过
    *pass({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(services.pass, id);
      callback(response);
    },
    //拒绝
    *reject({ payload: { id }, callback }, { call }) {
      const { data: response } = yield call(services.reject, id);
      callback(response);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
